import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const NPISecondaryIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M4.16667 0.833252C3.25 0.833252 2.5 1.58325 2.5 2.49992V13.3333C2.5 13.7933 2.87333 14.1666 3.33333 14.1666C3.79333 14.1666 4.16667 13.7933 4.16667 13.3333V3.33325C4.16667 2.87325 4.54 2.49992 5 2.49992H13.3333C13.7933 2.49992 14.1667 2.12659 14.1667 1.66659C14.1667 1.20659 13.7933 0.833252 13.3333 0.833252H4.16667ZM7.5 4.16659C6.58333 4.16659 5.83333 4.91659 5.83333 5.83325V17.4999C5.83333 18.4166 6.58333 19.1666 7.5 19.1666H16.6667C17.5833 19.1666 18.3333 18.4166 18.3333 17.4999V5.83325C18.3333 4.91242 17.5875 4.16659 16.6667 4.16659H7.5ZM10 7.49992H14.1667C14.6267 7.49992 15 7.87325 15 8.33325C15 8.79325 14.6267 9.16659 14.1667 9.16659H10C9.54 9.16659 9.16667 8.79325 9.16667 8.33325C9.16667 7.87325 9.54 7.49992 10 7.49992ZM10 10.8333H14.1667C14.6267 10.8333 15 11.2066 15 11.6666C15 12.1266 14.6267 12.4999 14.1667 12.4999H10C9.54 12.4999 9.16667 12.1266 9.16667 11.6666C9.16667 11.2066 9.54 10.8333 10 10.8333ZM10 14.1666H14.1667C14.6267 14.1666 15 14.5399 15 14.9999C15 15.4599 14.6267 15.8333 14.1667 15.8333H10C9.54 15.8333 9.16667 15.4599 9.16667 14.9999C9.16667 14.5399 9.54 14.1666 10 14.1666Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

NPISecondaryIcon.propTypes = {
  sx: PropTypes.object,
};

export default NPISecondaryIcon;
